import { DEFAULT_LATEST } from 'constants/dateLimits';
import { LegalAssociationsEngagedTerrorismItemModel } from 'forms/sections/legal/associations/engagedTerrorism/types';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';

const legalAssociationsEnagedTerrorismValidator: ValidateJSModel<LegalAssociationsEngagedTerrorismItemModel> = {
  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Reasons: { presence: true, hasValue: true },
};

export default legalAssociationsEnagedTerrorismValidator;
